export default {
    title: "收貨地址管理",
    table1: "姓名",
    table2: "地址",
    table3: "電話",
    table4: "默認",
    table5: "操作",
    isDefault: "否",
    isDel: "是否刪除當前地址？",
    addTitle: "添加收貨地址",
    form1: "收貨人姓名：",
    form2: "收貨地址：",
    form3: "聯繫電話：",
    form4: "電子郵箱：",
    form5: "傳真：",
    form6: "設為默認收貨地址",
    rule1: "請輸入收貨人姓名",
    rule2: "請輸入收貨地址",
    rule3: "請輸入聯繫電話",
    rule4: "請輸入電子郵箱",
    diaTitle: "編輯修改"
}